<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت سفارشات</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px;">
            <v-card>
                <v-card-title>
                    <v-layout wrap row>
                        <v-flex xs12 sm12 lg6 md6 xl6 style="padding:20px">
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:10px;">
                                    <div class="page-title" style="font-size:13px !important;">
                                        <v-icon color="baseColor" small>fas fa-search</v-icon>
                                        جستجو
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:30px;background-color:#EEEEEE;border-bottom:1px solid #aaa;border-left:1px solid #aaa">
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field outlined v-model="schUser" dense placeholder="جستجو بر اساس نام و نام خانوادگی"></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field outlined v-model="schPhone" dense placeholder="جستجو بر اساس تلفن همراه"></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <date-picker v-model="schSdate" :clearable="true" />
                                        </v-col>
                                        <v-col cols="6">
                                            <date-picker v-model="schEdate" :clearable="true" />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field outlined v-model="schMail" dense placeholder="جستجو بر اساس شماره پیگیری / Public Key"></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                           <v-btn color="baseColor" :loading="inSearching" @click="searchSuggestion" dense block dark>جستجو</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 lg6 md6 xl6 style="padding:30px">
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:10px;">
                                    <div class="page-title" style="font-size:13px !important;">
                                        <v-icon color="baseColor" small>fas fa-filter</v-icon>
                                        فیلتر
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm12 md12 lg12 xl12 >
                                    <v-row>
                                        <v-col cols="12">
                                            <v-row>
                                                <v-col cols="5" style="font-size:13px;">
                                                    وضعیت  :
                                                </v-col>
                                                <v-col cols="7">
                                                    <v-radio-group @change="filterChanged($event)" v-model="sStatus">
                                                        <v-radio :value="-1" label="همه"></v-radio>
                                                        <v-radio v-for="(item,index) in InvoiceStates" :key="index" :value="item.value" :label="item.text"></v-radio>
                                                       
                                                    </v-radio-group>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-row>
                                                <v-col cols="7" style="font-size:13px;">
                                                    نوع پرداخت :
                                                </v-col>
                                                <v-col cols="5">
                                                    <v-radio-group @change="PayFilterChanged($event)" v-model="PayTypeFilter">
                                                        <v-radio :value="0" label="همه"></v-radio>
                                                        <v-radio :value="1" label="پرداخت آنلاین"></v-radio>
                                                        <v-radio :value="2" label="پرداخت  در محل"></v-radio>
							<v-radio :value="3" label="پرداخت  از کیف پول"></v-radio>
                                                      
                                                    </v-radio-group>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" style="border-top:1px solid #aaa">
                                            <JsonExcel :data="dtData" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExcelFields">
                                                <v-btn dark color="baseColor">
                                                    <v-icon small style="padding-left:5px;">fas fa-file-excel</v-icon>&nbsp;
                                                    خروجی اکسل
                                                </v-btn>
                                            </JsonExcel>
                                        </v-col>
                                    </v-row>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text>
                    <v-data-table :items="dtData" :headers="dtHeaders">
                        <template v-slot:[`item.paymentType`]="{ item }">
                            <span v-if="item.paymentType == 1">آنلاین</span>
                            <span v-if="item.paymentType == 2">در محل</span>
			    <span v-if="item.paymentType == 3">کیف پول</span>
                            
                        </template>
                        
                        <template v-slot:[`item.operation`]="{ item }">
                            <v-btn small icon  @click="DisplayProducts(item)"><v-icon small color="orange" >fas fa-eye</v-icon></v-btn>
                            <v-btn small icon   :href="'https://homekito.com/Print/'+item.code"><v-icon small color="blue" >fas fa-print</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
        </v-layout>
        <template>
            <v-dialog fullscreen v-model="ProductsTableDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                            <v-app-bar dense color="rgb(42, 45, 69)" dark>
                                <v-toolbar-title style="color:orange">
                                    <span>محصولات سفارش</span>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-icon color="orange" @click="ProductsTableDialog = false" small>fa fa-times</v-icon>
                            </v-app-bar>
                        </v-card-title>                    
                        <v-card-text>
                        <v-data-table :headers="ProductsTableHeader" :items="ProductsTableItems">
                            <template v-slot:[`item.Total`]="{ item }">
                                {{item.quantity * item.price}}
                            </template>
                           
                        </v-data-table>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md5 lg5 xl5 class="pa-5">
                                <div v-if="DisplayProducts && selectedItem.reciption != null">
                                    <div style="display:flex;width:100%;paddint-top:60px;justify-content:center;align-items:center;font-weight:bolder">اطلاعات تحویل گیرنده</div>
                                    <v-row>
                                        <v-col cols="6"><v-chip>نام</v-chip></v-col>
                                        <v-col cols="6">{{selectedItem.reciption.name}}</v-col>
                                        <v-col cols="6"><v-chip>تلفن</v-chip></v-col>
                                        <v-col cols="6">{{selectedItem.reciption.phone}}</v-col>
                                        <v-col cols="6"><v-chip>تلفن ثابت</v-chip></v-col>
                                        <v-col cols="6">{{selectedItem.reciption.tel}}</v-col>
                                        <v-col cols="6"><v-chip>کد پستی</v-chip></v-col>
                                        <v-col cols="6">{{selectedItem.reciption.zipCode}}</v-col>
                                        <!-- <v-col cols="2"><v-chip>آدرس</v-chip></v-col>
                                        <v-col cols="10">{{selectedItem.reciption.address}}</v-col> -->
                                    </v-row>
                                </div>
                            </v-flex>
                            <v-flex xs12 sm12 md7 lg7 xl7 class="pa-5">
                                <div style="display:flex;width:100%;paddint-top:60px;justify-content:center;align-items:center;font-weight:bolder">تغییر وضعیت فاکتور</div>
                                <v-row>
                                    <v-col cols="4">وضعیت فاکتور</v-col>
                                    <v-col cols="6">
                                        <v-autocomplete :items="InvoiceStates" item-value="value" item-text="text" dense outlined v-model="selectedItem.status"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-btn @click="ChangeInvoiceState(selectedItem.id,selectedItem.status)" small block  color="purple accent-3" dark>
                                            <v-icon style="padding-left:5px" color="#fff" small>fa fa-check</v-icon> تغییر وضعیت سفارش
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template>
            <v-dialog fullscreen v-model="TicketDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                            <v-app-bar dense color="rgb(42, 45, 69)" dark>
                                <v-toolbar-title style="color:orange">
                                    <span>تیکت  سفارش</span>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-icon color="orange" @click="TicketDialog = false" small>fa fa-times</v-icon>
                            </v-app-bar>
                        </v-card-title>                    
                        <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px;">
                              <v-timeline>
                            <v-timeline-item v-for="n in Ticket" :key="'tf'+n.id+Math.random(0,10)" :right="!n.right" :left="n.right">
                                <span slot="opposite">{{n.date}}</span>
                                <v-card class="elevation-2">
                                    <v-card-title>
                                        {{n.user}}
                                    </v-card-title>
                                    <v-card-text>
                                        {{n.body}}
                                    </v-card-text>
                                </v-card>
                            </v-timeline-item>
                            </v-timeline>
                          </v-flex>
                      </v-layout>
                  </v-card-text>
                  <v-card-actions>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md11 lg11 xl11 style="padding:20px;">
                            <v-textarea outlined v-model="ticketResponse" dense height="40" placeholder="پاسخ به کاربر">

                            </v-textarea>
                        </v-flex>
                        <v-flex xs12 sm12 md1 lg1 xl1 style="padding:20px;"> 
                            <v-btn :loading="RegTicketRespLoading" @click="RegisterResponse" color="baseColor" block dark>ارسال</v-btn>
                        </v-flex>
                      </v-layout>   
                  </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
    
</template>

<script>
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");

const axios = require('axios');
import JsonExcel from 'vue-json-excel'
import { async } from 'q';
export default {
    components:{
        JsonExcel
    },
    name:"invoice",
    data:()=>({
        sStatus:-1,
        PayTypeFilter:0,
        dtHeaders:[
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"شماره فاکتور",value:"code",sortable:true,align:"right"},
            {text:"نام و نام خانوادگی",value:"user",sortable:true,align:"right"},
            {text:"تلفن ",value:"phone",sortable:true,align:"right"},
            {text:" ایمیل",value:"email",sortable:true,align:"right"},
            {text:"جمع مبلغ",value:"sumProducts",sortable:true,align:"right"},
            {text:"مبلغ کل",value:"sum",sortable:true,align:"right"},
            {text:"کد تخفیف",value:"couponCode",sortable:true,align:"right"},
            {text:"درصد تخفیف",value:"couponPerc",sortable:true,align:"right"},
            {text:"نوع پرداخت",value:"paymentType",sortable:true,align:"right"},
            {text:"نام بانک",value:"bankName",sortable:true,align:"right"},
            {text:" شماره کارت",value:"cardNumber",sortable:true,align:"right"},
            {text:"تاریخ پرداخت ",value:"paymentDate",sortable:true,align:"right"},
            {text:"وضعیت ",value:"statusStr",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        ProductTableHeaders:[
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"عنوان محصول",value:"Title",sortable:true,align:"right"},
            {text:"تعداد ",value:"Count",sortable:true,align:"right"},
            {text:"قیمت",value:"Price",sortable:true,align:"right"},
            {text:"جمع",value:"Total",sortable:true,align:"right"},
        ],
        dtData:[],
        prodItems:[],
        Repository:[],
        ExcelFields:{
            'شماره فاکتور ':'code',
            'نام کاربر':'user',
            'تلفن کاربر':'phone',
            'ایمیل کاربر':'email',
            'جمع مبلغ ':'sumProducts',
            'مبلغ کل':'sum',
            'کد تخفیف':'couponCode',
            'نوع پرداخت':'paymentType',
            'نام بانک':'bankName',
            'شماره کارت':'cardNumber',
            'تاریخ پرداخت ':'paymentDate',
            'وضعیت':'statusStr',
        },
        schUser:null,
        schPhone:null,
        schSdate:null,
        schEdate:null,
        schMail:null,
        inSearching:false,
        OperationItem:[],
        AcceptDialog:false,
        DissmissDialog:false,
        InAcceptingRequest:false,
        dismissReason:"",
        InDismissingRequest:false,
        RequestStatusReportDialog:false,
        ProductsTableDialog:false,
        ProductsTableItems:[],
        ProductsTableHeader:[
            {text:"#",value:"Counter",sortable:true,align:"right"},
            {text:"عنوان محصول",value:"name",sortable:true,align:"right"},
            {text:"تعداد ",value:"quantity",sortable:true,align:"right"},
            {text:"قیمت اصلی",value:"priceWODiscount",sortable:true,align:"right"},
            {text:"قیمت با تخفیف",value:"price",sortable:true,align:"right"},
            {text:"جمع",value:"Total",sortable:true,align:"right"},
        ],
        InvoiceStates:[
            {text:"ثبت موفق",value:1},
            {text:"تستی",value:2},
            {text:"پرداخت آنلاین",value:3},
            {text:"پرداخت در محل",value:4},
            {text:"لغو شده",value:5},
            {text:"پرداخت آنلاین ، ارسال و تحویل شده",value:6},
            {text:"پرداخت در محل ، ارسال و تحویل شده",value:7},
            {text:"ارسال نشده",value:8},
            {text:"پرداخت آنلاین ، ارسال نشده",value:9},
            {text:"انصراف از خرید",value:10},
            {text:"ناموجود",value:11},
        ],
        selectedItem:{reciption:null},
        TicketDialog:false,
        Ticket:[],
        Entity:0,
        RegTicketRespLoading:false,
        ticketResponse:"",
    }),
    created(){
        this.loadSuggestions();
    },
    methods:{
        async ChangeInvoiceState(id,st)
        {
            let vm = this;
            
            var url=ApiUrl.ChangeInvoiceState+'/'+id+'/'+st;
            
            await axios.post(url)
                .then( async function (res) {
                    console.log(res);
                    if(res.data.status)
                    {
                        vm.ProductsTableDialog = false;
                       await vm.loadSuggestions();
                       console.warn(res.data.data);
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        },
        async RegisterResponse()
        {
            var vm = this;
            let Model = {};
            Model.T_Cid = vm.Entity;
            Model.T_Userid = 0;
            Model.T_Body = vm.ticketResponse;
            await axios.post(ApiUrl.AddTicket, Model)
            .then(async function (res) {
                var data = res.data;
                if (data.status) {
                    MSGHNDL.OK(data.msg);
                    vm.ticketResponse = "";
                    await vm.LoadTickets();
                }
                else {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch(function (err) {
                console.error(err);
            });
        },
        async DisplayTicket(item)
        {
            let vm = this;
            vm.TicketDialog = true;
            vm.Entity = item.code;
            await vm.LoadTickets();
        },
        async LoadTickets()
        {
            let vm = this;
            await axios.post(ApiUrl.Ticket.GetEntity+"/"+vm.Entity)
            .then((res)=>{
                var data = res.data;
                if(data.status)
                {
                    vm.Ticket = data.data;
                }
            })
            .catch((err)=>{console.error(err)});
        },
        DisplayStatusReport(item)
        {
            let vm = this;
            vm.AcceptDialog = true;
            vm.prodItems = item.Products;
            
        },
        DisplayProducts(item)
        {
            let vm = this;
            vm.ProductsTableDialog = true;
            vm.ProductsTableItems = item.products;
            vm.selectedItem = item;
        },
        async DismissRequest()
        {
            let vm = this;
            vm.InDismissingRequest = true;
            let url = "https://saviz.com/api/request/DissmisWalletRequest";
            let data = new FormData();
            let model = {};
            model.RequestId = vm.OperationItem.RequestId;
            model.Reason = vm.dismissReason;
            data.append("DissmisModel",JSON.stringify(model));
            await axios.post(url,data)
            .then(async (res)=>{
                console.log(res);
                if(res.data.status)
                {
                    vm.DissmissDialog = false;
                    await vm.loadSuggestions();
                }
                vm.InDismissingRequest = false;
            })
            .catch((err)=>{vm.InDismissingRequest = false;console.log(err);});
        },
        async AcceptRequest()
        {
            let vm = this;
            vm.InAcceptingRequest = true;
            let url = "http://saviz.com/api/request/AcceptWalletRequests";
            let data = new FormData();
            data.append("RequestId",vm.OperationItem.RequestId);
            await axios.post(url,data)
            .then(async (res)=>{
                console.log(res);
                if(res.data.status)
                {
                    vm.AcceptDialog = false;
                    await vm.loadSuggestions();
                }
                vm.InAcceptingRequest = false;
            })
            .catch((err)=>{vm.InAcceptingRequest = false;console.log(err);});
        },
        DisplayDismissDialog(item)
        {
            let vm = this;
            vm.OperationItem = item;
            vm.DissmissDialog = true;
        },
        DisplayAcceptDialog(item)
        {
            let vm = this;
            vm.OperationItem = item;
            vm.AcceptDialog = true;
        },
        async searchSuggestion()
        {
            let vm = this;
            vm.sStatus = 2;
            let data = {};
            if(vm.schUser != null)
            {
                data.User = vm.schUser;
            }
            if(vm.schPhone != null)
            {
                data.Phone = vm.schPhone;
            }
            if(vm.schSdate != null)
            {
                data.StartDate = vm.schSdate;
            }
            if(vm.schEdate != null)
            {
                data.EndDate = vm.schEdate;
            }
            if(vm.schMail != null)
            {
                data.Email = vm.schMail;
            }

                let sheet = {};
                sheet.searchModel = data; 
                var url="https://saviz.com/api/setting/communication/searchConsultation";
                const config = 
                {
                    
                    url:url,
                    method: 'post',
                    data:sheet
                }
                await axios(config)
                    .then(function (res) {
                       
                        // vm.inUploading = false;
                        if(res.data.status)
                        {
                        vm.dtData = res.data.data;
                        vm.Repository = res.data.data;
                            // vm.documentFile = res.data.data;
                        }
                    })
                    .catch(function (error) {
                    
                    console.log(error);
                    });
            
        },
        async PayFilterChanged(e)
        {
            let vm = this;
           let f = e;
           vm.status = 0;
           if(f == 0)
           {   
                
                vm.dtData = vm.Repository;
          
               
           }
           else
           {
                vm.dtData = await vm.Repository.filter(({PayTypeBool})=>PayTypeBool == f );
           }
        },
        async filterChanged(e)
        {
           let vm = this;
           vm.PayTypeFilter = 0;
           let f = e;
           if(f == -1)
           {   
                
                vm.dtData = vm.Repository;
          
               
           }
           else
           {
                vm.dtData = await vm.Repository.filter(({StatusBool})=>StatusBool == f );
           }
        },
        async loadSuggestions()
        {
            let vm = this;
            var url=ApiUrl.LoadInvoices+"/1";
            
            await axios.post(url)
                .then(function (res) {
                    console.log(res);
                    vm.inUploading = false;
                    if(res.data.status)
                    {
                       vm.dtData = res.data.data;
                       vm.Repository = res.data.data;
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        }
    }
}
</script>